// extracted by mini-css-extract-plugin
export default {"heading":"KB-z","corrected":"LB-z","redirectVerbiageContainer":"MB-z","redirectVerbiageText":"NB-z"};